export const MAX_CHARACTER_LIMIT = 350;
